// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"61b14e10","307":"984df84c"}[chunkId] + ".chunk.js";
};